import styled from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
export var SaleBadgeContainer = styled.div.withConfig({
  componentId: "sc-px320k-0"
})(["position:relative;font-weight:", ";"], font.weight.bold);
export var SaleBadgeLabel = styled.div.withConfig({
  componentId: "sc-px320k-1"
})(["position:absolute;top:0;padding:18px 20px 20px 20px;color:", ";text-align:center;"], colors.white);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/SaleBadge/styled.js
// module id = 3983
// module chunks = 11